export const budgetConstants = {
  SET_BUDGET_REQUEST: 'SET_BUDGET_REQUEST',
  SET_BUDGETS: 'SET_BUDGETS',
  CLEAR_BUDGET_REQUEST: 'CLEAR_BUDGET_REQUEST',
  ADD_BUDGET_TO_STORE: 'ADD_BUDGET_TO_STORE',
  UPDATE_BUDGET_IN_STORE: 'UPDATE_BUDGET_IN_STORE',
};
